import {
  IsCardBeforePaidCutoffHandler,
  useIsCardBeforePaidCutoff,
} from '@shared/data/billing/hooks/useIsCardBeforePaidCutoff';
import {
  CardsEntityService,
  CardsEntityServiceProps,
  useCardService,
} from '@shared/data/cards/CardsEntityService';
import { useOpenEntityById } from '@shared/scenes/cards/collectionView/hooks/useOpenByEntityId';

export type OpenEntityHandler = (id: string, navigationViewTemplateId: string | null) => void;

export interface CollectionViewDataProps extends CardsEntityServiceProps {
  baseNavigationPath: string;
}

export interface CollectionViewData extends CardsEntityService {
  openEntity: OpenEntityHandler;
  getIsCardBeforePaidCutoff: IsCardBeforePaidCutoffHandler;
}

export function useCollectionViewData({
  workflowTemplateId,
  viewTemplateId,
  workspaceId,
  pageSize,
  baseNavigationPath,
}: CollectionViewDataProps): CollectionViewData {
  const cardService = useCardService({ workflowTemplateId, viewTemplateId, pageSize, workspaceId });
  const openEntity = useOpenEntityById(baseNavigationPath, workflowTemplateId);
  const getIsCardBeforePaidCutoff = useIsCardBeforePaidCutoff();

  return {
    ...cardService,
    openEntity,
    getIsCardBeforePaidCutoff,
  };
}
